import * as tslib_1 from "tslib";
import { BreakpointObserver } from '@angular/cdk/layout';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { GlobalFunctionService } from '@providers/global-function/global-function.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var ChapterComponent = /** @class */ (function () {
    function ChapterComponent(requestService, breakpointObserver, globalFunction, requestV2Service, globalDataService) {
        var _this = this;
        this.requestService = requestService;
        this.globalFunction = globalFunction;
        this.requestV2Service = requestV2Service;
        this.globalDataService = globalDataService;
        this.isMobile = false;
        this.isServiceLoaded = false;
        breakpointObserver.observe(['(min-width: 800px)']).subscribe(function (result) {
            _this.isMobile = result.matches;
        });
    }
    ChapterComponent.prototype.calculateTotalChapterPrice = function () {
        var _this = this;
        if (this.globalDataService) {
            var findChapter = this.globalDataService.financial.customer.chapters
                .find(function (i) { return i.id_quotation_chapter === _this.chapter.id; });
            if (findChapter) {
                return findChapter.total;
            }
        }
        return 0;
    };
    ChapterComponent.prototype.openChapter = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var servicesResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestV2Service.getServices(this.chapter.id)];
                    case 1:
                        servicesResult = _a.sent();
                        this.services = servicesResult.items;
                        this.isServiceLoaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    return ChapterComponent;
}());
export { ChapterComponent };
